// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.card-item {\n  overflow: unset;\n}\n.hide {\n  max-height: 0;\n  overflow: hidden;\n  padding: 0;\n}\n.show {\n  max-height: 100rem;\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
